<template>
  <div>
    <ul>
      <component :is="resolveNavItemComponent(item)" v-for="item in items" :key="item.header || item.title"
        :item="item" />
    </ul>
    <div>
      <audio ref="audioPlayer">
        <source src="@/assets/audio/ALAR.mp3" type="audio/mpeg">
      </audio>
      <audio ref="audioPlayer2">
        <source src="@/assets/audio/ALARM8.mp3" type="audio/mpeg">
      </audio>
      <audio ref="audioPlayer3">
        <source src="@/assets/audio/ALARM10.mp3" type="audio/mpeg">
      </audio>
      <audio ref="audioPlayer4">
        <source src="@/assets/audio/ALARM11.mp3" type="audio/mpeg">
      </audio>
    </div>
  </div>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import request from '@/utils/request.js';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      timer1: '',
      dxqnum: '',
      rqnum: '',
      jqnum: '',
      voiceFlag: '',
      switchVoice: '',
      numData: "",
      cp_numData: {}
    };
  },

  created() {

    let token = localStorage.getItem('footy_token');
    if (!token) {
      return false;
    }
    this.accountData();
    this.voiceFlag = localStorage.getItem('footy_voiceFlag'),
      this.switchVoice = localStorage.getItem('footy_switchVoice'),
      //每隔三秒，去查询一次状态
      this.timer1 = setInterval(() => {
        this.accountData();
      }, 30000);
  },

  destroyed() {
    // 清理定时器
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  },

  methods: {

    showToast(variant, position, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon: 'InfoIcon',
          text,
          variant,
        },
      },
        {
          position,
        })
    },

    // 选择声音
    openVoice() {
      if (!this.switchVoice) {
        return;
      }
      if (this.voiceFlag == 'voice1') {
        this.playSound1();
      }
      if (this.voiceFlag == 'voice2') {
        this.playSound4();
      }
      if (this.voiceFlag == 'voice3') {
        this.playSound3();
      }
      if (this.voiceFlag == 'voice4') {
        this.playSound2();
      }
    },

    playSound1() {
      const audioPlayer = this.$refs.audioPlayer;
      audioPlayer.play();
    },
    playSound2() {
      const audioPlayer = this.$refs.audioPlayer2;
      audioPlayer.play();
    },
    playSound3() {
      const audioPlayer = this.$refs.audioPlayer3;
      audioPlayer.play();
    },
    playSound4() {
      const audioPlayer = this.$refs.audioPlayer4;
      audioPlayer.play();
    },


    async accountData() {
      let token = localStorage.getItem('footy_token');
      if (!token) {
        return;
      }
      this.voiceFlag = localStorage.getItem('footy_voiceFlag');
      this.switchVoice = localStorage.getItem('footy_switchVoice');

      const oldDxqnum = localStorage.getItem('footy_dxqnum');
      const oldRqnum = localStorage.getItem('footy_rqnum');
      const oldJqnum = localStorage.getItem('footy_jqnum');
      var post_url =
        'football/admin/william/interfaceAction!receiveRollerNum.action?sjlx=007&';
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      await request.httpRequest(opts).then(res => {
        if (res.status == 200) {
          if (res.data.status == 1) {
            this.dxqnum = res.data.data.dxqnum;
            this.rqnum = res.data.data.rqnum;
            this.jqnum = res.data.data.jqnum;

            if (Number(this.dxqnum) - Number(oldDxqnum) > 0) {
              this.openVoice();
              this.showToast('success', 'bottom-right', '新的滚球大小球比赛', '请及时查看')
            }
            if (Number(this.rqnum) - Number(oldRqnum) > 0) {
              this.openVoice();
              this.showToast('success', 'bottom-right', '新的滚球亚让比赛', '请及时查看')
            }
            // if (Number(this.jqnum) - Number(oldJqnum) > 0) {
            //   this.openVoice();
            //   this.showToast('success', 'bottom-right', '新的滚球角球比赛', '请及时查看')
            // }
            localStorage.setItem('footy_dxqnum', this.dxqnum);
            localStorage.setItem('footy_rqnum', this.rqnum);
            // localStorage.setItem('footy_jqnum', this.jqnum);
          }
        }
      })
      post_url =
        'football/admin/william/interfaceAction!receiveRollerNum.action?sjlx=ttyq&';
      opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      await request.httpRequest(opts).then(res => {
        if (res.status == 200) {
          if (res.data.status == 1) {
            // this.cp_dxqnum = res.data.data.dxqnum;
            // this.cp_rqnum = res.data.data.rqnum;
            this.cp_numData = res.data.data;
            localStorage.setItem('footy_cp_dxqnum', res.data.data.dxqnum);
            localStorage.setItem('footy_cp_rqnum', res.data.data.rqnum);
            // localStorage.setItem('footy_cp_jqnum', res.data.data.jqnum);
          }
        }
      })

    }

  },

  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
